class ShareResourceUsersController {
  static controller($scope, $state, $stateParams, ResourceService) {
    'ngInject';

    $scope.resource = ResourceService.getUserResource($stateParams.resourceUniqueId);
    console.log('ShareResourceUsersController', $scope.resource);
    $scope.share = function(form){
      if(!form.$valid){
        return;
      }
      console.log('sharing resource', form);
      ResourceService.shareResourceForInstalator($scope.resource, form.licenseId.$modelValue, form.hours.$modelValue)
      .then(function(data){
        $scope.shareSuccess = true;
      });
    }
  };
}

export default ShareResourceUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/client/shareResource.users.controller.js